import { render } from "./App.vue?vue&type=template&id=6d219cf3&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6d219cf3&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=6d219cf3&lang=css"

import exportComponent from "/usr/app/color_sensor/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d219cf3"]])

export default __exports__